(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ajax-add-to-cart"] && !Shopify.designMode) return;
  try {
    /* ===== Config ===== */
const CART_SECTION_ID     = 'cart-drawer';
const CART_SECTIONS       = ['cart-drawer','cart-icon-bubble'];
const CART_SECTIONS_QUERY = CART_SECTIONS.join(',');
const SECTIONS_URL_BASE   = '/cart';

/* ===== Helpers ===== */
function findDrawer(){
  return document.querySelector('cart-drawer')
      || document.getElementById('CartDrawer')
      || document.querySelector('.cart-drawer,[data-cart-drawer]');
}
function forceOpenCart(){
  document.getElementById('CartDrawer-Overlay')?.remove();
  document.querySelector('.cart-drawer__overlay')?.remove();
  document.documentElement.classList.remove('js-cart-open','drawer-open');
  document.body.classList.remove('js-cart-open','drawer-open','overflow-hidden');

  const dw = findDrawer();
  if (dw && typeof dw.open === 'function') { try { dw.open(); } catch(e){} }
  else if (dw) {
    dw.classList.add('active','is-open','drawer--active');
    dw.removeAttribute?.('hidden'); dw.setAttribute?.('aria-hidden','false');
  } else {
    const t = document.querySelector('[data-cart-toggle], .js-cart-toggle, [aria-controls="CartDrawer"], [data-drawer-id="CartDrawer"], a[href="#CartDrawer"]');
    if (t) t.dispatchEvent(new MouseEvent('click',{bubbles:true})); else window.location.href='/cart';
    return;
  }
  document.dispatchEvent(new CustomEvent('cart:open'));
  document.body.dispatchEvent(new CustomEvent('cart:open'));
}

function patchDrawerWithSection(html){
  if (!html) return;
  const host = document.getElementById('shopify-section-'+CART_SECTION_ID);
  if (host) {
    host.outerHTML = html;
  } else {
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const newItems = tmp.querySelector('cart-drawer-items')
                  || tmp.querySelector('#CartDrawer-Cart')
                  || tmp.querySelector('[data-cart-drawer-items]')
                  || tmp.querySelector('.drawer__inner')
                  || tmp.querySelector('form[action^="/cart"]');
    const curDrawer = findDrawer();
    const curItems = curDrawer && (curDrawer.querySelector('cart-drawer-items')
                  || curDrawer.querySelector('#CartDrawer-Cart')
                  || curDrawer.querySelector('[data-cart-drawer-items]')
                  || curDrawer.querySelector('.drawer__inner')
                  || curDrawer.querySelector('form[action^="/cart"]'));
    if (newItems && curItems) {
      if (newItems.tagName?.toLowerCase()==='cart-drawer-items' && curItems.tagName?.toLowerCase()==='cart-drawer-items') curItems.replaceWith(newItems);
      else curItems.innerHTML = newItems.innerHTML;
    }
  }
  const dw = findDrawer();
  dw?.classList?.remove('is-empty','is-transitioning');
  dw?.setAttribute?.('aria-hidden','false');
}

function fetchCartSectionHTMLOnce(){
  const url = new URL(SECTIONS_URL_BASE, window.location.origin);
  url.searchParams.set('section_id', CART_SECTION_ID);
  url.searchParams.set('t', Date.now());
  return fetch(url.toString(), {
    headers: { 'Accept':'text/html','Cache-Control':'no-store' },
    credentials: 'same-origin'
  }).then(r => { if(!r.ok) throw new Error('section_id '+r.status); return r.text(); });
}

function addViaAjaxWithSections(variantId, qty, sellingPlanId){
  const fd = new FormData();
  fd.append('id', variantId);
  fd.append('quantity', qty);
  if (sellingPlanId) fd.append('selling_plan', sellingPlanId);
  const url = `/cart/add.js?sections=${encodeURIComponent(CART_SECTIONS_QUERY)}&sections_url=${encodeURIComponent(SECTIONS_URL_BASE)}`;
  return fetch(url, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Cache-Control': 'no-store' },
    credentials: 'same-origin',
    body: fd
  }).then(r => { if(!r.ok) return r.json().then(j=>{throw j;}); return r.json(); });
}

/* ===== Main ===== */
(function(){
  if (window.__ajaxAddToCartBound) return;
  window.__ajaxAddToCartBound = true;

  document.addEventListener('click', function(e){
    const el = e.target.closest('.active-cart');
    if (!el) return;
    if (el.matches('[data-add-to-cart]')) return;
    e.preventDefault();
    forceOpenCart();
  });

  function setBtnLoading(btn, isLoading){
    if (!btn) return;
    btn.disabled = isLoading;
    const label = btn.querySelector('.text-btn');
    if (label) label.textContent = isLoading ? 'ADDING…' : 'ADD TO CART';
  }

  let inflight = false;

  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    if (btn.hasAttribute('data-has-options')) {
      window.location.href = btn.getAttribute('data-product-url') || '/products';
      return;
    }

    const variantId    = btn.getAttribute('data-variant-id');
    let qty            = parseInt(btn.getAttribute('data-qty') || '1', 10);
    qty                = isNaN(qty) || qty < 1 ? 1 : qty;
    const sellingPlanId = btn.getAttribute('data-selling-plan') || null;

    if (!variantId) { window.location.href = btn.getAttribute('data-product-url') || '/products'; return; }

    if (inflight) return; inflight = true;
    setBtnLoading(btn, true);
    const done = () => { inflight = false; setBtnLoading(btn, false); };

    const renderAndOpen = (parsed) => {
      const drawer = findDrawer();
      if (drawer && typeof drawer.renderContents === 'function' && parsed?.sections) {
        drawer.renderContents(parsed);
      } else if (parsed?.sections?.[CART_SECTION_ID]) {
        patchDrawerWithSection(parsed.sections[CART_SECTION_ID]);
      }
      forceOpenCart();

      setTimeout(() => {
        fetchCartSectionHTMLOnce().then(patchDrawerWithSection).then(forceOpenCart).catch(()=>{});
      }, 1000);

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    };

    if (window.CartJS && typeof CartJS.addItem === 'function') {
      CartJS.addItem(variantId, qty, {}, {
        success: function(){
          fetchCartSectionHTMLOnce()
            .then(patchDrawerWithSection)
            .then(() => {
              forceOpenCart();
              setTimeout(() => {
                fetchCartSectionHTMLOnce().then(patchDrawerWithSection).then(forceOpenCart).catch(()=>{});
              }, 1000);
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            })
            .finally(done);
        },
        error: function(err){ console.warn('[CartJS]', err); done(); }
      });
      return;
    }

    addViaAjaxWithSections(variantId, qty, sellingPlanId)
      .then(renderAndOpen)
      .catch(err => console.warn('[add.js]', err))
      .finally(done);
  });

  document.addEventListener('click', function(e){
    const isRemove = e.target.closest('[data-cart-remove], .cart-remove, button[name="remove"], a[href*="change?"][href*="quantity=0"]');
    if (!isRemove) return;
    setTimeout(() => {
      fetchCartSectionHTMLOnce()
        .then(patchDrawerWithSection)
        .then(forceOpenCart)
        .finally(() => {
          setTimeout(() => {
            fetchCartSectionHTMLOnce().then(patchDrawerWithSection).then(forceOpenCart).catch(()=>{});
          }, 1000);
        });
    }, 150);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
